<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    clipped
    dark
  >
    <v-list dense>
      <template v-for="(item, index) in menu">
        <v-list-item
          v-if="!('children' in item)"
          :key="item.text"
          :to="item.path"
          append-icon="mdi-account"
        >
          <v-list-item-icon>
            <v-icon v-text="item.meta.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-else
          :prepend-icon="item.meta.icon"
          :key="item.name+index"
          no-action
          active-class="grey darken-2 white--text"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, index) in item.children"
            :key="item.name+child.name+index"
            :to="item.path + '/' + child.path"
            active-class="grey darken-4 white--text no-hover"
            class="ma-0 pl-10"
          >
            <v-list-item-icon class="mr-2">
              <v-icon size=20 v-text="child.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="child.meta.title || child.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers, mapMutations } from 'vuex'
const { mapState:authState, mapActions:authActions } = createNamespacedHelpers('auth')
export default {
  name: 'NavigationDrawer',
  data () {
    return {
      menuStatus: false,
    }
  },
  computed: {
    ...authState(['user']),
    // subMenu() {
    //   return [
    //     { name: 'Sair', icon: 'mdi-account-arrow-right', click: 'logout', vIf: true },
    //     { name: 'Ativar Notificações', icon: 'mdi-bell-alert', click: 'enableNotification', vIf: true },
    //     { 
    //       name: 'Siga-me',
    //       icon: 'mdi-cellphone-message',
    //       click: 'toggleFollowMe',
    //       vIf: (this.user && this.user.claims) ? this.user.claims.allowFollowMe : false,
    //       vActive: (this.user && this.user.claims) ? this.user.claims.followMe : false 
    //     }
    //   ]
    // },
    isAdmin() { return (this.user) ? this.user.claims.admin : false },
    drawer: {
      get(){
        return this.$store.state.drawer
      },
      set(val){
        this.$store.commit('setDrawer', val)
      } 
    },
    menu() {
      const items = this.$_.cloneDeep(this.$router.options.routes)
        .filter(route => 
          route.meta.menu && 
          (
            route.path == '/' || this.user.claims.admin ||
            ( /*!route.meta.requiresAdmin &&*/
              // this.user.rules && this.user.rules.find(ur => eval(`ur?.claims?.${route.register}?.view`))
              this.user.rules && this.user.rules.find(ur => (ur?.claims[route.register]) ? ur?.claims[route.register].view : false)
            )
          )
        )
        .map(route => {
          delete route.component
          if ('children' in route)
            route.children = route.children
              .map(childRoute => {
                delete childRoute.component
                return childRoute
              })
              .filter(childRoute => {
                return childRoute.meta.menu && (this.user.claims.admin ||
                ( /*!route.meta.requiresAdmin &&*/
                  // this.user.rules && this.user.rules.find(ur => eval(`ur?.claims?.${route.register}?.meta?.${childRoute.claimRoute}`))
                  this.user.rules && this.user.rules.find(ur => (ur?.claims[route.register]) ? ur?.claims[route.register][childRoute.meta.claimRoute] : false)
                ))})
          return route
        })
      return items
    }
  },
  methods: {
    ...mapMutations(['showSnackbar']),
    ...authActions(['signOut', 'toggleFollowMe']),
    handleClick(e) {
      if(e) this[e]()
    },
    handleVar(e) {
      if(e) return this[e]
    },
    allowed(meta) {
      let allowed = true
      //if (meta.requiresAdmin && !this.isAdmin) { allowed = false }
      if (meta.requireClaim && (!this.$appConfig.claims || !this.$appConfig.claims[meta.requireClaim])) { allowed = false }
      return allowed
    },
    // logout() {
    //   this.signOut()
    // },
    enableNotification: function (event) {
      // `event` is the native DOM event
      this.$notification
        .requestPermission()
        .then(res => {
          if (res == 'granted') {
            this.showSnackbar({text: 'Noficações ativas', color: 'info'})
          } else {
            this.showSnackbar({text: 'Erro ao ativar notificações, verifique as configurações do seu navegador', color: 'error'})
          }
        }) 
    }
  },
  created() {
    this.$notification
      .requestPermission()
  }
}
</script>

<style>

</style>